// Charge la base commune
import './common.js'

// Newsletter Form
async function getNForm ($f) {
  $f.load()
  import(/* webpackChunkName: "newsletterForm" */ './js/components/newsletterForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // formulaire newsletter
  const $c5 = $('form[name="nForm"]')
  if ($c5.length) {
    $c5.waypoint(function () {
      getNForm($c5)
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
